import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const URL = `${process.env.REACT_APP_BACKEND_URL}/advancePaymentReturn`;

const initialState = { isLoading: false, error: null, returns: [], advancePaymentReturn: null, page: 1, limit: 10, totalPages: 0, totalResults: 0 };

const slice = createSlice({
  name: "accountsAdvancePaymentReturn",
  initialState,
  reducers: {
    startLoading(state) { state.isLoading = true; state.error = null; },
    hasError(state, action) { state.isLoading = false; state.error = action.payload; },
    getManySuccess(state, action) {
      const payload = action.payload?.data || action.payload || {};
      state.isLoading = false;
      state.returns = payload.results || payload.advancePaymentReturns || (Array.isArray(payload) ? payload : []);
      state.page = payload.page || 1; state.limit = payload.limit || 10; state.totalPages = payload.totalPages || 0;
      state.totalResults = payload.totalResults ?? state.returns.length;
    },
    getOneSuccess(state, action) { state.isLoading = false; state.advancePaymentReturn = action.payload?.data || action.payload; },
    clearAdvancePaymentReturn(state) { state.advancePaymentReturn = null; state.error = null; },
  },
});

export default slice.reducer;
export const { clearAdvancePaymentReturn } = slice.actions;

export const getAccountsAdvancePaymentReturns = ({ franchiseId, page = 1, limit = 10 }) => async (dispatch) => {
  dispatch(slice.actions.startLoading());
  try { const response = await axios.get(URL, { params: { franchiseId, page, limit } }); dispatch(slice.actions.getManySuccess(response.data)); return response.data; }
  catch (error) { dispatch(slice.actions.hasError(error)); throw error; }
};

export const getAccountsAdvancePaymentReturn = (id) => async (dispatch) => {
  dispatch(slice.actions.startLoading());
  try { const response = await axios.get(`${URL}/${id}`); dispatch(slice.actions.getOneSuccess(response.data)); return response.data; }
  catch (error) { dispatch(slice.actions.hasError(error)); throw error; }
};

export const createAccountsAdvancePaymentReturn = (data) => async (dispatch) => {
  dispatch(slice.actions.startLoading());
  try { const response = await axios.post(URL, data); dispatch(slice.actions.getOneSuccess(response.data)); return response.data; }
  catch (error) { dispatch(slice.actions.hasError(error)); throw error; }
};

export const updateAccountsAdvancePaymentReturn = (id, data) => async (dispatch) => {
  dispatch(slice.actions.startLoading());
  try { const response = await axios.patch(`${URL}/${id}`, data); dispatch(slice.actions.getOneSuccess(response.data)); return response.data; }
  catch (error) { dispatch(slice.actions.hasError(error)); throw error; }
};
